import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-building',
  templateUrl: './building.component.html',
  styleUrls: ['./building.component.styl']
})
export class TodoBuildingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
